
<div class="content-container">
  <div class="content">
    <mat-card class="card-color">
      <mat-card-content>
        <div class="header-container">
          <div class="data">
            <div class="contact-data">
              <div class="id">
                Orden de Compra #{{inventoryActionForBuyOrder?.correlative_id}} <span class="date">{{inventoryActionForBuyOrder?.created_at | date}}</span> 
              </div>

              <div class="sub-header">
                Compañía y Datos de contacto
              </div>
              <div class="company">
                {{company.name}}
              </div>
              @if (requester?.name) {
              <div class="name">
                {{requester.name}}
              </div>
              }
              @if (requester?.mail) {
              <div class="sub-name">
                {{requester.mail}}
              </div>
              }
              @if (requester?.phone) {
              <div class="sub-name">
                {{requester.phone}}
              </div>
              }
            </div>

          
            @if (requiredDeliveryDate) {
              <div class="field">
                <span class="fieldname">Fecha requerida para la entrega: </span>
                <span class="fieldvalue"> {{requiredDeliveryDate | date}}</span>
              </div>
            }
          </div>
          <div class="expander"></div>
          <div class="logo-container">
            <div class="logo view-desktop">
              <img [src]="company.preferences.logo || 'assets/images/logo.svg'" alt="Company logo">
            </div>
            
          </div>
        </div>

        <app-inventory-action-for-buy-order-form
          [parentFormGroup]="(form | formGroup)"
          [canUpdate]="!inventoryActionForBuyOrder?.finish || inventoryActionForBuyOrder?.draft"
          [canAddItem]="false"
          [enableEstimatedCompletionDate]="true"
          [enableDiscounts]="false"
          (dataChanged)="updateInventoryAction()"
        >
        </app-inventory-action-for-buy-order-form>
        <div class="buttons">
         
          <div class="save-state">
            @if (saving()) {
              <mat-icon>hourglass_empty</mat-icon><div>Guardando cambios...</div>
            }
            @else {
              <div class="saved">Cambios guardados</div>
            }
          </div>
          <div class="expander"></div>
          @if (inventoryActionForBuyOrder?.finish && !inventoryActionForBuyOrder?.draft) {
            <div class="finish">
              <mat-icon>done</mat-icon><span>Finalizado</span>
            </div>
          } @else {
            <button mat-raised-button type="button" color="accent" [disabled]="!form.valid || saving() || (inventoryActionForBuyOrder?.finish && !inventoryActionForBuyOrder?.draft)" (click)="confirm()">
              Confirmar Orden de Compra
            </button>
        }
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div> 

<div class="extender"></div>
<div class="footer">
  <a href="https://www.controlcar.app">Powered by <img src='assets/images/logo.svg' alt="logo"></a>
</div>

